import type { ZoneType, ZoneWatchStatus } from '@chukua/common';

export const ZONE_TYPE_LABELS: Record<ZoneType, string> = { place: 'Place', boundary: 'Boundary' };

/** What the panel's Watching line says; `starting` is the minute before the sweep has set the watch up. */
export const ZONE_WATCH_STATUS_LABELS: Record<ZoneWatchStatus, string> = {
  watching: 'Watching',
  starting: 'Starting, within a minute',
  off: 'Off: arrivals and departures are not recorded',
  inactive: 'Off: this zone is deactivated',
  no_shape: 'Nothing to watch yet: draw the zone on the map',
};

const COUNTRY_NAMES = new Intl.DisplayNames(['en'], { type: 'region' });

/** `KE` → "Kenya". The API stores the ISO code; the office reads a name. */
export function countryName(countryCode: string | null): string | null {
  if (!countryCode) return null;
  return COUNTRY_NAMES.of(countryCode) ?? countryCode;
}

/** "800 m" up to a kilometre, then "1.5 km": how a point zone's reach reads in a table or panel. */
export function formatRadius(radiusMeters: number): string {
  if (radiusMeters < 1000) return `${radiusMeters} m`;
  return `${Number((radiusMeters / 1000).toFixed(1))} km`;
}
